import Store from 'app/redux/store'
import { bindActions } from 'redux-zero/utils'

const Basic = bindActions(
  () => ({
    // Update single column
    update: (state, key: string, value: any) => ({
      pages: {
        ...state.pages,
        business: {
          ...state.pages.business,
          main: {
            ...state.pages.business.main,
            [key]:
              (key === 'fb_dataset_id' ||
                key === 'fb_page_id' ||
                key === 'instagram_id' ||
                key === 'offline_event_set_id') &&
              !value
                ? null
                : value,
          },
        },
      },
    }),
    // Merges into fb_business_info (BM name/picture per Facebook Builder asset field) — unlike `update`,
    // this lives directly on `business`, not `business.main`, since fb_business_info is only ever
    // resolved server-side for display and never sent back as part of the BusinessConfig save DTO.
    updateFbBusinessInfo: (state, patch: Record<string, any>) => ({
      pages: {
        ...state.pages,
        business: {
          ...state.pages.business,
          fb_business_info: {
            ...state.pages.business.fb_business_info,
            ...patch,
          },
        },
      },
    }),
  }),
  Store
)

export default Basic
